import React from 'react'
import './work.css'
//import Zoom from 'react-reveal/Zoom'

function WorkHistory() {
    return (
        <div className="work-t">
        <h1 className="work-t-h1" >Work History</h1>
        <div className="work">
        
   
        <div className="work-detail">
        <div className="company" >
        <h2>Company</h2>
        <h4>MR Web Technology</h4>
        
        </div>
      
        <div className="designation">
        <h2>Designation</h2>
        <h4>Php Developer</h4>
        <p> </p>

        
        </div>
        <p>Build a CMS (Content-Management-System) </p>
        <p>Build Informative Websites</p>
        <p>Build Admin Panel for different websites</p>
        <p>Learned different web desining tools like Bootstrap</p>
    
        </div>
        
        <div className="work-detail">
        <div className="company" >
        <h2>Company</h2>
        <h4>Epik Solutions</h4>
        
        </div>
        <div className="designation">
        <h2>Designation</h2>
        <h4>Php Developer</h4>
        <p> </p>

        
        </div>
        <p>Build E-Commerce Websites </p>
        <p>Integrated Laravel - Angular project using api </p>
        <p>Build website estimator project</p>
        <p>Used Payment Gateways api</p>
  
        </div>
        
        
        <div className="work-detail">
        <div className="company" >
        <h2>Company</h2>
        <h4>Gazing Technosoft</h4>
        
        </div>
        <div className="designation">
        <h2>Designation</h2>
        <h4>Php Developer</h4>
        <p> </p>

        
        </div>
      
        <p> Build E-Commerce of Medicine Products </p>
        <p> Created Image / Video digital, physical products website </p>
        <p> Worked on Api creation and used built in Api </p>
        <p> Build projects of resort, steel manufacturing and ca</p>
      
        </div>
        
        <div className="work-detail">
        <div className="company" >
        <h2>Company</h2>
        <h4>IT Answers</h4>
        
        </div>
      
        <div className="designation">
        <h2>Designation</h2>
        <h4>Php Developer</h4>
        <p> </p>

        
        </div>
        <p>Worked on ERP (Enterprise resource planning) </p>
        <p>Build Projects</p>
        <p>Use github and gitlab for version control</p>
        <p>Learned different web technologies and implemented in different projects</p>
    
        </div>
            
        </div>
        </div>
    )
}

export default WorkHistory
